import React, { useEffect, useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../../data/SiteConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, fal } from '@fortawesome/pro-light-svg-icons';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import DateFilter from '../PopupFilter/FilterComponents/DateFilter';
import RM from '../PopupFilter/FilterComponents/RmList';
import Source from '../PopupFilter/FilterComponents/Source';
import rmICon from '../../../images/icons/PopUpFilter/rmImg.svg';
import PopupFilter from '../PopupFilter/PopupFilter';
import FilterListIcon from '@material-ui/icons/FilterList';
import SvgComponent from '../SvgComponent/SvgComponent';
import DetailsIcon from '@material-ui/icons/Details';
import { getReflexReport } from '../../../common/constants/api';
import {
  getFiltersInfo,
  setFiltersInfo
} from '../../../../../lems-ui/src/common/utils/FiltersInfo';
import moment from 'moment';
import {
  tableRows,
  boxShadow,
  fullScreen
} from './LeadReflexReport.module.css';
import InfiniteScroll from '../InfiniteScroll/InfiniteScroll';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import { navigate } from 'gatsby';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
const LeadReflexReport = () => {
  //master filter state
  const [showFilter, setShowFilter] = useState(false);
  const [shoHtmlSelectedFileds, setHtmlSelectedFileds] = useState('');
  const [masterFilters, setMasterFilters] = useState(
    getFiltersInfo()?.reflexReport || {}
  );

  //custome pagination state
  const [pageInfo, setPageInfo] = useState({});
  const [rows, setRows] = useState('50');
  const [page, setPage] = useState(0);

  //table related state
  const [leadReflexData, setLeadReflexData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dontShowData, setDontShowData] = useState(false);

  //filter state
  const [source, setSource] = useState('');
  const [rmId, setRmId] = useState('');
  const [fromDate, setFromDate] = useState(moment().format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'));
  // mountingstatus
  const [veryFirstCall, setVeryFirstCall] = useState(true);
  const [showFullScreen, setShowFullScreen] = useState(false);

  const tableHead =
    'font-barlow py-4 text-grey-ShuttleGray text-base font-medium px-3 sticky top-0 bg-white';
  const tableBody = `font-roboto text-grey-ShuttleGray100 text-md font-normal px-4 py-4 `;

  const commonUpperStyle = { maxHeight: '20px', maxWidth: '20px' };

  const rmImg = ({ className, style }) => (
    <SvgComponent
      img={rmICon}
      className={className}
      style={{ ...style, ...commonUpperStyle }}
    />
  );

  const dataList = [
    {
      img: CalendarTodayIcon,
      title: 'Date',
      name: 'date',
      component: DateFilter
    },
    {
      img: rmImg,
      title: 'RM',
      name: 'rm',
      component: RM
    },
    {
      img: DetailsIcon,
      title: 'Source',
      name: 'source',
      component: Source,
      dependencyData: { multiSelect: true }
    }
  ];

  const appledFilters = async e => {
    setDontShowData(true);
    if (veryFirstCall) return;
    setFiltersInfo({
      ...(getFiltersInfo() || {}),
      reflexReport: e
    });
    setPage(0);
    let startDate = moment(e?.dateFilter?.startDate).format('YYYY-MM-DD');
    let endDate = moment(e?.dateFilter?.endDate).format('YYYY-MM-DD');
    let source = Object.keys(e?.source || {})?.toString();
    let rm = Object.keys(e?.rm || {})?.toString();
    getLeadReflexReport({
      from: startDate,
      to: endDate,
      pageNumber: 0,
      pageSize: rows,
      rm: rm,
      source: source,
      notConsiderOlderData: true
    });

    setFromDate(startDate);
    setToDate(endDate);
    setRmId(rm);
    setSource(source);
  };

  const getLeadReflexReport = async apiData => {
    setLoading(true);
    await getReflexReport(apiData)
      .then(res => {
        setVeryFirstCall(false);
        if (apiData?.notConsiderOlderData) {
          setLeadReflexData(res?._embedded?.leadInfluxReportDtoList || []);
        } else {
          setLeadReflexData(
            [...leadReflexData, ...res?._embedded?.leadInfluxReportDtoList] ||
              []
          );
        }
        setLoading(false);
        setPageInfo(res?.page || {});
        setPage(res?.page?.number);
        setRows(res?.page?.size);
        setDontShowData(false);
      })
      .catch(error => {
        setLoading(false);
        setLeadReflexData(leadReflexData || []);
        setDontShowData(false);
      });
  };

  useEffect(() => {
    let startDate = moment(masterFilters?.dateFilter?.startDate).format(
      'YYYY-MM-DD'
    );
    let endDate = moment(masterFilters?.dateFilter?.endDate).format(
      'YYYY-MM-DD'
    );
    let source = Object.keys(masterFilters?.source || {})?.toString();
    let rm = Object.keys(masterFilters?.rm || {})?.toString();

    getLeadReflexReport({
      from: startDate || fromDate,
      to: endDate || toDate,
      pageNumber: page,
      pageSize: rows,
      rm: rm,
      source: source
    });
    setFromDate(startDate);
    setToDate(endDate);
    setRmId(rm);
    setSource(source);
  }, []);

  const getResponseTimeFormat = time => {
    if (!time) return <span>---</span>;
    if (time < 1) return <span>{parseInt(time * 60)} Sec</span>;
    else if (time >= 1 && time < 60) return <span>{parseInt(time)} Min</span>;
    else if (time >= 60 && time < 24 * 60)
      return <span>{(time / 60)?.toFixed(1)} Hour</span>;
    else return <span>{parseInt(time / (24 * 60))} days</span>;
  };

  const handleInfiniteScroll = async () => {
    if (veryFirstCall) return;
    await getLeadReflexReport({
      from: fromDate,
      to: toDate,
      pageNumber: page + 1,
      pageSize: rows,
      rm: rmId,
      source: source
    });
  };

  const handleNavigatToCallLog = async ({ leadId }) => {
    let filters = getFiltersInfo();
    await setFiltersInfo({
      ...(filters || {}),
      callLogs: {
        callMade: {
          startDate: filters?.reflexReport?.dateFilter?.startDate || new Date(),
          toDate: filters?.reflexReport?.dateFilter?.endDate || new Date()
        },
        callType: {
          ...(filters?.callLogs?.callType || {})
        },
        rm: filters?.reflexReport?.rm
      }
    });
    navigate(`/app/calllog/${leadId}`);
  };

  function handleKeyPress(e) {
    if (e.key === 'Escape') {
      setShowFullScreen(false);
    }
  }

  useEffect(() => {
    window?.addEventListener('keyup', handleKeyPress);
    return () => window?.removeEventListener('keyup', handleKeyPress);
  }, []);
  return (
    <React.Fragment>
      <Helmet title={`Reflex Report | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full  font-roboto text-sm font-normal m-0 p-0 ">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />
          <div className="w-full max-screen">
            <div className="w-full flex">
              <div className="flex items-center  flex-col xl:flex-row w-full">
                <div className="w-full text-black-400 text-md ml-4 font-bold mt-4 ">
                  <span className="mr-1 cursor-pointer">Reports</span>
                  <FontAwesomeIcon
                    icon={faAngleDoubleRight}
                    className="mr-1 mt-1"
                  />
                  <span className="text-green-800">Lead Reflex Report</span>
                </div>
              </div>
              <Header />
            </div>
            <div className="px-3 w-full  py-5 mt-3">
              <div
                className={`bg-white rounded-md w-full ${boxShadow} pb-7  ${showFullScreen &&
                  fullScreen}`}
              >
                <div className="w-full  py-4 px-5">
                  <div className="w-full xl:flex block xl:flex-wrap ">
                    <div className="w-full flex items-center">
                      <div
                        className="cursor-pointer py-1   "
                        style={{ width: '150px' }}
                        onClick={() => setShowFilter(true)}
                      >
                        <div className="border border-grey-2235 rounded flex py-2 px-4">
                          <p className="text-grey-2236 font-roboto font-normal text-sm">
                            Filter
                          </p>
                          <div className="table ml-auto ">
                            <FilterListIcon style={{ color: '#8a939e' }} />
                          </div>
                        </div>
                      </div>

                      <p className="text-grey-2236 font-roboto font-normal text-sm ml-5">
                        {pageInfo?.totalElements || 'No'}
                        <span> Records Found</span>
                      </p>
                      <div className="table float-right ml-auto mr-0">
                        {!showFullScreen && (
                          <FullscreenIcon
                            className="text-grey-2236 cursor-pointer"
                            onClick={() => setShowFullScreen(true)}
                          />
                        )}
                        {showFullScreen && (
                          <FullscreenExitIcon
                            className="text-grey-2236  cursor-pointer"
                            onClick={() => setShowFullScreen(false)}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="w-full flex flex-wrap">
                    {Object.keys(shoHtmlSelectedFileds || {}).map(
                      each => shoHtmlSelectedFileds[each]
                    )}
                  </div>
                </div>

                <div className="w-full h-full ">
                  <div className="w-full overflow-auto">
                    <InfiniteScroll
                      bottomLocation={100}
                      debounceTime={100}
                      handleScrollsuccess={handleInfiniteScroll}
                      disable={false}
                      pageInfo={pageInfo}
                      includeFilterLoder={loading}
                    >
                      <table className="w-full">
                        <thead>
                          <tr>
                            <td className={`${tableHead} pl-5`}>SL No.</td>
                            <td className={tableHead}>RM Name</td>
                            <td className={tableHead}>Lead ID</td>
                            <td className={tableHead}>Customer Name</td>
                            <td className={tableHead}>
                              Lead Source Date & Time
                            </td>
                            <td className={tableHead}>1st Call Date & Time</td>
                            <td className={tableHead}>Response</td>
                            <td className={`${tableHead} text-right pr-7`}>
                              Avg. Response Time
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          {!dontShowData &&
                            leadReflexData?.map((each, index) => (
                              <tr key={index} className={`${tableRows}`}>
                                <td className={`${tableBody} pl-5`}>
                                  {index + 1}
                                </td>

                                <td className={`${tableBody}`}>{`${each?.rmName
                                  ?.firstName || ''} ${each?.rmName
                                  ?.middleName || ''} ${each?.rmName
                                  ?.lastName || ''}`}</td>
                                <td className={`${tableBody}`}>
                                  <span
                                    onClick={() =>
                                      handleNavigatToCallLog({
                                        leadId: each?.leadId
                                      })
                                    }
                                    className="text-blue-600  cursor-pointer "
                                  >
                                    {each?.leadId}
                                  </span>
                                </td>
                                <td className={`${tableBody}`}>
                                  {`${each?.applicantName?.firstName ||
                                    ''} ${each?.applicantName?.middleName ||
                                    ''} ${each?.applicantName?.lastName || ''}`}
                                </td>
                                <td className={`${tableBody}`}>
                                  {each?.leadSourceDateTime ? (
                                    <span>
                                      {moment(each?.leadSourceDateTime).format(
                                        'DD-MM-YYYY'
                                      )}
                                      <p>
                                        {moment(
                                          each?.leadSourceDateTime
                                        ).format('hh:mm A')}
                                      </p>
                                    </span>
                                  ) : (
                                    '---'
                                  )}
                                </td>
                                <td className={`${tableBody}`}>
                                  {each?.firstcallDateTime ? (
                                    <span>
                                      {moment(each?.firstcallDateTime).format(
                                        'DD-MM-YYYY'
                                      )}
                                      <p>
                                        {moment(each?.firstcallDateTime).format(
                                          'hh:mm A'
                                        )}
                                      </p>
                                    </span>
                                  ) : (
                                    '---'
                                  )}
                                </td>
                                <td className={`${tableBody} `}>
                                  {each?.response == 'Not Responded' ? (
                                    <span className="text-red-wildWatermelon">
                                      {each?.response}
                                    </span>
                                  ) : (
                                    <span>{each?.response}</span>
                                  )}
                                </td>
                                <td className={`${tableBody} text-right pr-7`}>
                                  {getResponseTimeFormat(
                                    each?.responseTimeMinutes
                                  )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      {!loading &&
                        leadReflexData?.length != 0 &&
                        leadReflexData?.length == pageInfo?.totalElements && (
                          <div className="table text-center mx-auto">
                            No More Data Available!
                          </div>
                        )}
                      {!loading && leadReflexData?.length == 0 && (
                        <div className="table text-center mx-auto">
                          No Data Available!
                        </div>
                      )}
                    </InfiniteScroll>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <PopupFilter
          show={showFilter}
          setShow={setShowFilter}
          dataList={dataList}
          handleApply={appledFilters}
          handleToastBlock={e => setHtmlSelectedFileds(e)}
          masterFiltersData={masterFilters}
        />
      </div>
    </React.Fragment>
  );
};

export default LeadReflexReport;
